import { render } from "./InputForm.vue?vue&type=template&id=11ffcea4"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/cavilam/boutique/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__